import store from "../src/store";

export default {
  eAmount() {
    let orderID = [];
    let selected = store.getters.getChartReportEnt;
    if (selected) {
      selected.forEach(function(i) {
        let datas = i["amount"];
        orderID.push(datas);
      });
    }

    return orderID;
  },
  eDayMonth() {
    let orderID = [];
    let selected = store.getters.getChartReportEnt;
    if (selected) {
      selected.forEach(function(i, index) {
        if (index < 50) {
          let datas = i["dayMonth"];
          orderID.push(datas);
        }
      });
    }

    return orderID;
  }
};
